import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createProfessional, CreateProfessionalInput } from "../services/create-professional";
import { toast } from "@/hooks/use-toast";

export function useCreateProfessional() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateProfessionalInput) => createProfessional(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["professionals"] });
      toast({ title: "Professional created successfully" });
    },
    onError: (error: any) => {
      console.error("Error creating professional:", error);
      // Nest's validation errors arrive as an array of messages.
      const message = error?.response?.data?.message;
      toast({
        title: "Failed to create professional",
        description: Array.isArray(message) ? message.join(", ") : message,
        variant: "destructive",
      });
    },
  });
}
